import { useCallback, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useFireAnalyticsEvents } from '@/analytics';
import { SourceKey, ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useUserInfo } from '@/common/hooks';
export const use404DisplayAnalytics = () => {
	const location = useLocation();
	const { fireScreenEvent, fireUIEvent } = useFireAnalyticsEvents();

	const { data: user } = useUserInfo();

	// Screen event - when 404 page is displayed
	useEffect(() => {
		if (!user) return;

		fireScreenEvent({
			name: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
			attributes: {
				userDomain: user.userDomain.domain,
				pageRoute: location.pathname,
			},
		});
	}, [fireScreenEvent, user, location.pathname]);

	// UI event callback for home link click
	const sendGoBackToHomeLinkClickUIEvent = useCallback(() => {
		if (!user) return;

		fireUIEvent({
			action: ActionKey.CLICKED,
			actionSubject: ActionSubjectKey.LINK,
			actionSubjectId: ActionSubjectIdKey.GO_BACK_TO_HOME_LINK,
			source: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
			attributes: {
				userDomain: user.userDomain.domain,
				pageRoute: location.pathname,
			},
		});
	}, [fireUIEvent, user, location.pathname]);

	return {
		sendGoBackToHomeLinkClickUIEvent,
	};
};
